import { initReactI18next, useTranslation } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationsEn from "./locales/en.json";
import translationsRu from "./locales/ru.json";

const resources = {
  en: { translations: translationsEn },
  ru: { translations: translationsRu }
};

export type SupportedLanguage = "en" | "ru";

// ?lang= is what QA and the API use to force a locale, so it wins over the saved one.
const requestedLanguage = new URLSearchParams(window.location.search).get("lang");
const savedLanguage = localStorage.getItem("language");


const i18nextInstance = i18n
  .use(LanguageDetector)
  .use(initReactI18next)

const init = i18nextInstance.init({
  resources,
  fallbackLng: "en",
  lng: requestedLanguage ?? savedLanguage ?? undefined,
  supportedLngs: ["en", "ru"],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false // react already safes from xss
  },
  react: {
    bindI18n: "loaded languageChanged",
    bindI18nStore: "added",
    useSuspense: true
  }
})

// i18n.language can carry a region tag ("en-GB"); resolvedLanguage is what
// supportedLngs settled on, and it is the only thing the API understands.
const resolveLanguage = (i18n: { resolvedLanguage?: string }) =>
  (i18n.resolvedLanguage ?? "en") as SupportedLanguage;

const changeLanguage = async (lng: string, cb?: (lng: string) => void) => {
  localStorage.setItem("language", lng);
  await i18nextInstance.changeLanguage(lng);
  cb?.(lng)
};

export { i18nextInstance, init, changeLanguage, resolveLanguage };
